export class AppInput extends HTMLElement {
    constructor() {
        super();
    }

    // Se ejecuta automáticamente cuando el componente se inserta en el DOM
    connectedCallback() {
        this.render();
    }

    // Método para observar cambios en los atributos
    static get observedAttributes() {
        return ['label', 'type', 'placeholder', 'formControlName', 'input-id', 'inline-label'];
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue && this.innerHTML !== '') {
            this.render();
        }
    }

    render() {
        const label = this.getAttribute("label") || "";
        const type = this.getAttribute("type") || "text";
        const placeholder = this.getAttribute("placeholder") || "";
        const controlName = this.getAttribute("formControlName") || "";
        const inputId = this.getAttribute("input-id") || "";
        const inlineLabel = this.getAttribute("inline-label") === "true";

        if (inlineLabel) {
            this.innerHTML = `
                <div class="form-inline-wrapper">
                    ${label ? `<label for="${inputId}" class="form-inline-label">${label}</label>` : ''}
                    <input 
                        ${inputId ? `id="${inputId}"` : ''}
                        ${controlName ? `formControlName="${controlName}"` : ''} 
                        type="${type}" 
                        placeholder="${placeholder}" 
                        class="form-inline-input" 
                    />
                </div>
                ${controlName ? `<span formErrorFor="${controlName}" class="text-red-600 text-xs font-medium block min-h-[1.25rem] px-1 transition-all duration-150"></span>` : ''}
            `;
            return;
        }

        // Al retirar el <div> envolvente, el propio <app-input> servirá como contenedor
        this.innerHTML = `
            ${label ? `<label class="form-label">${label}</label>` : ''}
            <input 
                ${inputId ? `id="${inputId}"` : ''}
                ${controlName ? `formControlName="${controlName}"` : ''} 
                type="${type}" 
                placeholder="${placeholder}" 
                class="form-input" 
            />
            ${controlName ? `<span formErrorFor="${controlName}" class="text-red-600 text-xs font-medium block min-h-[1.25rem] px-1 transition-all duration-150"></span>` : ''}
        `;
    }
}

// Registrar el Web Component en el navegador
if (typeof window !== 'undefined') {
    customElements.define('app-input', AppInput);
}
